module.exports = __webpack_public_path__ + "static/media/robo-hurto-danos_new.c17eebb5.jpg";